import { type TranslationRecord } from "~/services/translations/getTranslationByKey";

export const translations = {
  fileUpload: {
    select: {
      de: "Datei auswählen",
    },
    addAnother: {
      de: "Weitere Datei auswählen",
    },
    upload: {
      de: "Hochladen",
    },
    delete: {
      de: "Löschen",
    },
  },
  "delete-data": {
    back: {
      de: "Zurück ohne zu löschen",
    },
    confirm: {
      de: "Ja, Daten löschen",
    },
    footerLinkLabel: {
      de: "Persönliche Daten löschen",
    },
  },
  accordion: {
    show: {
      de: "Einblenden",
    },
    hide: {
      de: "Ausblenden",
    },
    accordionItemShow: {
      de: "Einblenden",
    },
    accordionItemHide: {
      de: "Ausblenden",
    },
  },
  details: {
    textExample: {
      de: "Textbeispiele",
    },
  },
  select: {
    placeholder: {
      de: "Bitte auswählen",
    },
    bothParents: {
      de: "Beide Elternteile",
    },
    parentSelectLabel: {
      de: "Die Person ist ein Kind von ...",
    },
    parentSelectRequired: {
      de: "Bitte wählen Sie eine Person aus",
    },
  },
  iban: {
    bankIdentified: {
      de: "Bank identifiziert",
    },
  },
  feedback: {
    heading: {
      de: "Haben Sie Fragen oder Anmerkungen?",
    },
    content: {
      de: "Diese Seite ist im Aufbau. Schreiben Sie uns an feedback-justiz-services@digitalservice.bund.de, wenn Ihnen etwas fehlt, oder etwas nicht funktioniert. Ihr Feedback trägt dazu bei, Informationen und Gestaltung der Webseite für alle Nutzenden zu verbessern.",
    },
    "yes-rating": {
      de: "Ja",
    },
    "no-rating": {
      de: "Nein",
    },
    "heading-feedback": {
      de: "Was können wir verbessern?",
    },
    "heading-personal-data-feedback": {
      de: "Bitte tragen Sie keine persönlichen Daten ein. Ihr Feedback wird anonym erfasst.",
    },
    "placeholder-feedback": {
      de: "Ihr Feedback...",
    },
    "submit-button-feedback": {
      de: "Abschicken",
    },
    "heading-post-submission": {
      de: "Vielen Dank!",
    },
    "text-post-submission": {
      de: "",
    },
    "success-message": {
      de: "Vielen Dank!",
    },
    "antwort-uebermittelt": {
      de: "Ihre Antwort wurde übermittelt",
    },
    "positive-feedback-question": {
      de: "Was hat Ihnen gefallen? (optional)",
    },
    "negative-feedback-question": {
      de: "Was können wir verbessern? (optional)",
    },
    "feedback-helps": {
      de: "Ihr Feedback hilft uns, diese Seite für alle Nutzenden zu verbessern.",
    },
    "report-problem": {
      de: "Problem mit dieser Seite melden",
    },
    "problem-gemeldet": {
      de: "Ihr Problem wurde gemeldet",
    },
    cancel: {
      de: "Abbrechen",
    },
    "submit-problem": {
      de: "Problem absenden",
    },
    close: {
      de: "Schließen",
    },
    "open-feedback-placeholder": {
      de: "Beschreibung des Problems ...",
    },
    "validation-error": {
      de: "Bitte treffen Sie eine Auswahl.",
    },
  },
  video: {
    "video-thumbnail": {
      de: "Vorschlau für Gebärdensprache",
    },
    "video-aktivieren": {
      de: "Zustimmen",
    },
    "datenschutz-header": {
      de: "Zustimmung für externen Inhalt erforderlich",
    },
    datenschutz: {
      de: "An dieser Stelle ist ein externer Inhalt eingebunden. Wir benötigen Ihre Zustimmung, damit Sie diesen anschauen können.",
    },
    zustimmung: {
      de: "Wir weisen Sie darauf hin, dass nach der Aktivierung Daten an Dritte übermittelt werden.",
    },
    "datenschutz-link": {
      de: "Datenschutzerklärung",
    },
  },
  pageHeader: {
    gebaerdensprache: {
      de: "Gebärdensprache",
    },
    leichtesprache: {
      de: "Leichte Sprache",
    },
    mainNavigationAriaLabel: {
      de: "Hauptmenü",
    },
    printPage: {
      de: "Diese Seite wurde heruntergeladen am",
    },
    time: {
      de: "Uhr",
    },
    at: {
      de: "um",
    },
  },
  currency: {
    euro: {
      de: "Euro",
    },
  },
  navigation: {
    navigationItemFinished: {
      de: "Abgeschlossen",
    },
    navigationItemWarning: {
      de: "Warnhinweis",
    },
    navigationStepper: {
      de: "Prozessübersicht",
    },
    linkOpensNewTab: {
      de: "öffnet neues Fenster",
    },
  },
  footer: {
    internalLinks: {
      de: "Rechtliche und weiterführende Informationen",
    },
    justizServices: {
      de: "Justiz-Services",
    },
    onlineDienste: {
      de: "Onlinedienste der Justiz",
    },
    rechtlicheHinweise: {
      de: "Rechtliche Hinweise",
    },
    impressum: {
      de: "Impressum",
    },
    barrierefreiheit: {
      de: "Barrierefreiheit",
    },
    datenschutz: {
      de: "Datenschutz",
    },
    kontaktUndTeilnahme: {
      de: "Kontakt und Teilnahme",
    },
    kontakt: {
      de: "Kontakt",
    },
    openSourceCode: {
      de: "Open Source Code",
    },
    anBefragungenTeilnehmen: {
      de: "An Befragungen teilnehmen",
    },
    persoenlicheDatenLoeschen: {
      de: "Persönliche Daten löschen",
    },
    pilotProjekt: {
      de: "Ein Pilotprojekt des",
    },
    bmjv: {
      de: "Bundesministeriums der Justiz und für Verbraucherschutz",
    },
    umsetztung: {
      de: "Umsetzung und Betrieb durch",
    },
    digitalService: {
      de: "DigitalService GmbH des Bundes",
    },
    projektZugangZumRecht: {
      de: "zugang-zum-recht-projekte.de",
    },
  },
  navigationMobile: {
    closeMenu: {
      de: "Schritt-für-Schritt-Menü schließen",
    },
    toggleMenu: {
      de: "Schritt-für-Schritt-Menü umschalten",
    },
    toStep: {
      de: "Zum Schritt:",
    },
  },
  buttonNavigation: {
    backButtonDefaultLabel: {
      de: "Zurück",
    },
    nextButtonDefaultLabel: {
      de: "Weiter",
    },
  },
  vorabcheck: {
    progressBarLabel: {
      de: "Vorab-Check Fortschritt",
    },
  },
  resultPage: {
    negativeResultIcon: {
      de: "Negatives Ergebnis",
    },
    positiveResultIcon: {
      de: "Positives Ergebnis",
    },
    warningIcon: {
      de: "Positives Ergebnis",
    },
    infoIcon: {
      de: "Information",
    },
  },
  inlineNotice: {
    warningIcon: {
      de: "Warnung",
    },
    infoIcon: {
      de: "Information",
    },
    errorIcon: {
      de: "Fehler",
    },
    successIcon: {
      de: "Erfolg",
    },
  },
  gerichtFinder: {
    streetName: {
      de: "Straße",
    },
    houseNumber: {
      de: "Hausnummer",
    },
    noResultsFound: {
      de: "Kein Eintrag gefunden",
    },
    inputRequired: {
      de: "Dieses Feld muss ausgefüllt werden.",
    },
    invalidHousenumber: {
      de: "Bitte geben Sie eine gültige Hausnummer an.",
    },
    autosuggestInputHelperText: {
      de: "Geben Sie Ihre Straße ein und wählen Sie diese anschließend aus der Trefferliste aus",
    },
  },
  xjustiz: {
    invalidCharacters: {
      de: "Folgende Zeichen sind in diesem Feld nicht erlaubt:",
    },
  },
  deleteDialog: {
    cancel: {
      de: "Nein, behalten",
    },
    confirm: {
      de: "Ja, löschen",
    },
    description: {
      de: "Folgendes wird entfernt:",
    },
    error: {
      de: "Das Löschen ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
    },
  },
  arraySummary: {
    arrayEditButtonLabel: {
      de: "Bearbeiten",
    },
    arrayDeleteButtonLabel: {
      de: "Löschen",
    },
    arrayAddButtonLabel: {
      de: "hinzufügen",
    },
  },
  dateComponent: {
    tagInputLabel: {
      de: "Tag",
    },
    monatInputLabel: {
      de: "Monat",
    },
    jahrInputLabel: {
      de: "Jahr",
    },
    legend: {
      de: "Geburtsdatum",
    },
    hintText: {
      de: "Beispielsweise: 17.11.2025",
    },
  },
  timeComponent: {
    hourInputLabel: {
      de: "Stunde",
    },
    minuteInputLabel: {
      de: "Minute",
    },
    invalidTime: {
      de: "Ungültige Uhrzeit",
    },
    invalidHour: {
      de: "Ungültige Stunde",
    },
    invalidMinute: {
      de: "Ungültiger Minute",
    },
  },
  numberIncrementComponent: {
    incrementButtonLabel: {
      de: "Erhöhen",
    },
    decrementButtonLabel: {
      de: "Reduzieren",
    },
  },
  autogeneratedSummary: {
    expandAllText: {
      de: "Alle einblenden",
    },
    collapseAllText: {
      de: "Alle ausblenden",
    },
    expandAllAriaLabelText: {
      de: "Alle Abschnitte sind bereits aufgeklappt",
    },
    collapseAllAriaLabelText: {
      de: "Alle Abschnitte sind bereits eingeklappt",
    },
  },
  homepage: {
    heroHeading: {
      de: "Onlinedienste der Justiz",
    },
    heroContent: {
      de: "Der Zugang zu Ihrem Recht – Hier erhalten Sie Informationen, Unterstützung bei der digitalen Antragstellung und der Kommunikation mit Gerichten",
    },
    headingOnlinedieste: {
      de: "Onlinedienste im Überblick",
    },
    boxProjektPartnerHeading: {
      de: "Ein Pilotprojekt des Bundesministeriums der Justiz und für Verbraucherschutz",
    },
    boxProjektPartnerContent: {
      de: "Die hier aufgeführten Onlinedienste werden derzeit im Rahmen eines Pilotprojekts des Bundesministeriums der Justiz und für Verbraucherschutz entwickelt und erprobt. Sie sollen schrittweise erweitert werden. Die Erprobung erfolgt in Projektpartnerschaft mit interessierten Ländern und Gerichten.",
    },
    boxProjektPartnerAltText: {
      de: "Logo des Bundesministeriums der Justiz und für Verbraucherschutz",
    },
    cardPrelineFGR: {
      de: "Digitale Zahlungsklage für Fluggastrechte",
    },
    cardHeadingFGR: {
      de: "Online-Verfahren: Geld bei Flugproblemen einfordern",
    },
    cardDescriptionFGR: {
      de: "Ihr Flug war verspätet, wurde annulliert oder Sie wurden nicht mitgenommen? Hier finden Sie Informationen darüber, welche Ansprüche und Handlungsoptionen Sie haben. Nach dem Vorab-Check können Sie direkt eine Klage erstellen, wenn sich das ermittelte Amtsgericht am Pilotprojekt beteiligt. Im Anschluss können Sie Ihre Klage selbst digital bei Gericht einreichen und ein Online-Verfahren eröffnen.",
    },
    cardButtonLabelFGR: {
      de: "Zu den Fluggastrechten",
    },
    cardPrelineTGA: {
      de: "Digitale Zahlungsklage",
    },
    cardHeadingTGA: {
      de: "Online-Verfahren: Geld von einer Person oder Organisation einfordern",
    },
    cardDescriptionTGA: {
      de: "Wenn Ihnen jemand Geld schuldet, können Sie vor Gericht klagen. Hier finden Sie Informationen zur allgemeinen Zahlungsklage im Online-Verfahren und welche Voraussetzungen es dafür gibt. Dieser Onlinedienst unterstützt Sie in bestimmten Fällen dabei, eine Klage zu erstellen. Im Anschluss können Sie Ihre Klage selbst digital bei Gericht einreichen und ein Online-Verfahren eröffnen.",
    },
    cardButtonLabelTGA: {
      de: "Zur Zahlungsklage",
    },
    cardPrelineBerH: {
      de: "Beratungshilfe",
    },
    cardHeadingBerH: {
      de: "Finanzielle Hilfe für ein Gespräch mit einer Anwältin oder einem Anwalt erhalten",
    },
    cardDescriptionBerH: {
      de: "Hier finden Sie Informationen über Beratungshilfe und welche Voraussetzungen es dafür gibt. Sie können mit dem Vorab-Check prüfen, ob der Staat die Kosten für die anwaltliche Beratung übernimmt und direkt den Antrag auf Beratungshilfe ausfüllen.",
    },
    cardButtonLabelBerH: {
      de: "Zur Beratungshilfe",
    },
    cardPrelinePKH: {
      de: "Prozesskostenhilfe",
    },
    cardHeadingPKH: {
      de: "Finanzielle Hilfe für ein Gerichtsverfahren erhalten",
    },
    cardDescriptionPKH: {
      de: "Mit der Prozesskostenhilfe werden die Kosten eines Gerichtsverfahrens finanziert. Sie können Prozesskostenhilfe bekommen, wenn Sie jemanden verklagen wollen oder verklagt wurden. Das Gericht entscheidet darüber, ob Sie Prozesskostenhilfe erhalten. Mithilfe eines Formulars müssen Sie dem Gericht nachweisen, dass Sie ansonsten die Kosten des Prozesses nicht zahlen können.",
    },
    cardButtonLabelPKH: {
      de: "Zur Prozesskostenhilfe",
    },
    cardPrelineKontopfaendung: {
      de: "Kontopfändung",
    },
    cardHeadingKontopfaendung: {
      de: "Geld bei einer Kontopfändung schützen",
    },
    cardDescriptionKontopfaendung: {
      de: "Wenn Ihr Konto gepfändet wurde oder eine Pfändung droht, gibt es Hilfe. Hier erfahren Sie, wie Sie Ihr Geld schützen und trotz einer Pfändung darauf zugreifen können. Der Wegweiser zeigt Ihnen, was Sie dafür tun müssen, welche Beträge und Guthaben Sie schützen können und welche Unterlagen nötig sind.",
    },
    cardButtonLabelKontopfaendung: {
      de: "Zum Wegweiser Kontopfändung",
    },
    headingLebenslagen: {
      de: "Lebenslagen",
    },
    headingHilfreicheInformationen: {
      de: "Hilfreiche Informationen",
    },
    cardPrelineRechtsprobleme: {
      de: "Rechtsprobleme",
    },
    cardHeadingRechtsprobleme: {
      de: "Rechtliche Unterstützung für Menschen mit wenig Geld",
    },
    cardDescriptionRechtsprobleme: {
      de: "Finden Sie Informationen zur Beratungshilfe, Prozesskostenhilfe und zu weiteren Beratungsmöglichkeiten.",
    },
    cardButtonLabelRechtsprobleme: {
      de: "Zu den finanziellen Hilfen",
    },
    cardPrelineNachlass: {
      de: "Nachlass",
    },
    cardHeadingNachlass: {
      de: "Einen Nachlass regeln",
    },
    cardDescriptionNachlass: {
      de: "Wenn jemand stirbt, müssen Angehörige entscheiden, ob sie ein Erbe annehmen oder ausschlagen. Hier erfahren Sie die wichtigsten Schritte.",
    },
    cardButtonLabelNachlass: {
      de: "Zum Nachlass",
    },
    headingMitmachen: {
      de: "Mitmachen",
    },
    cardPrelineAnleitung: {
      de: "Anleitung",
    },
    cardHeadingAnleitung: {
      de: "Anleitung: „Mein Justizpostfach“ einrichten",
    },
    cardDescriptionAnleitung: {
      de: "Mit „Mein Justizpostfach“ können Sie mit der Justiz kommunizieren und Dokumente online einreichen, zum Beispiel einen Antrag oder eine Klage.",
    },
    cardButtonLabelAnleitung: {
      de: "„Mein Justizpostfach“ einrichten",
    },
    cardPrelineStudie: {
      de: "Studie",
    },
    cardHeadingStudie: {
      de: "Gestalten Sie die digitalen Angebote der Justiz mit",
    },
    cardDescriptionStudie: {
      de: "Wir wollen digitale Justiz-Angebote entwickeln, die für alle Menschen gut funktionieren. Ihre Hilfe und Unterstützung ist dabei sehr wertvoll. Teilen Sie Ihre Erfahrungen mit uns. Testen Sie neue Angebote. Für viele Tests und Gespräche bekommen Sie als Dankeschön eine Aufwandsentschädigung, zum Beispiel einen Einkaufsgutschein.",
    },
    cardButtonLabelStudie: {
      de: "An Befragungen teilnehmen",
    },
    boxZugangeZumRecht: {
      de: "Digitale Zugänge zum Recht entwickeln und testen",
    },
    boxZugangeZumRechtContent: {
      de: "Wir schaffen und erproben neue Rahmenbedingungen, damit Rechtsuchenden der Zugang zum Recht erleichtert wird. Dabei übernimmt der Bund in Projektpartnerschaft mit interessierten Ländern und Gerichten eine koordinierende Rolle bei der Entwicklung und Erprobung der Onlinedienste. Die Erprobung erfolgt im Rahmen der Digitalisierungsprojekte Digitale Rechtsantragstelle und Zivilgerichtliches Online-Verfahren, die vom Bundesministerium der Justiz und für Verbraucherschutz in Zusammenarbeit mit der DigitalService GmbH des Bundes durchgeführt werden.",
    },
    boxZugangeZumRechtProjektLink: {
      de: "zugang-zum-recht-projekte.de",
    },
    boxZugangeZumRechtJustizLink: {
      de: "justiz.de",
    },
    cardPrelineErbausschlagung: {
      de: "Erbausschlagung",
    },
    cardHeadingErbausschlagung: {
      de: "Ein Erbe ablehnen",
    },
    cardDescriptionErbausschlagung: {
      de: "Hier finden Sie Informationen darüber, wie Sie eine Erbschaft ausschlagen können. Sie erfahren, welche Fristen Sie beachten müssen und welche Folgen die Ausschlagung hat.",
    },
    cardButtonLabelErbausschlagung: {
      de: "Zu Erbe ausschlagen",
    },
  },
  geldEinklagen: {
    begruendungBeschreibungHeadline: {
      de: "Abschnitt",
    },
    begruendungBeschreibungTitle: {
      de: "Beschreibung",
    },
    begruendungBeschreibungEditButton: {
      de: "Beschreibung bearbeiten",
    },
    begruendungBeschreibungDeleteButton: {
      de: "Abschnitt löschen",
    },
    begruendungBeschreibungEvidenceTitle: {
      de: "Beweise",
    },
    begruendungBeschreibungEvidenceDescription: {
      de: "Dokumente: zum Beispiel Fotos, Videos, Verträge, Rechnungen, sonstige Unterlagen. Personen: Zeugen oder Zeuginnen, in Ausnahmefällen Sie selbst oder die beklagte Person.",
    },
    begruendungBeschreibungEvidenceAddDocumentButton: {
      de: "Dokument beschreiben",
    },
    begruendungBeschreibungEvidenceAddPersonButton: {
      de: "Person angeben",
    },
    begruendungBeschreibungMaximumReachedTitleNotice: {
      de: "Maximale Anzahl an Abschnitten erreicht",
    },
    begruendungBeschreibungMaximumReachedContentNotice: {
      de: "Mit diesem Onlinedienst können Sie nicht mehr als 50 Abschnitte hinzufügen.",
    },
    summaryOverviewNoData: {
      de: "Keine Angaben",
    },
    summaryOverviewBoxBegruendungBeschreibungBeweiseNoDataNotice: {
      de: "Prüfen Sie, ob Sie tatsächlich keine Beweise zu diesem Abschnitt haben oder nennen möchten",
    },
    begruendungBeschreibungBeweiseBeklagteButtonArialLabel: {
      de: "Beklagte Person als Beweis",
    },
    begruendungBeschreibungBeweiseKlagendenButtonArialLabel: {
      de: "Klagende Person als Beweis",
    },
    begruendungBeschreibungBeweiseDocumentButtonArialLabel: {
      de: "Dieses Dokument",
    },
    begruendungBeschreibungBeweiseDocumentButtonArialLabelSuffix: {
      de: "und so weiter",
    },
    begruendungBeschreibungBeweisePersonNotFilled: {
      de: "Fehlende Angaben",
    },
    begruendungBeschreibungBeweisePersonWithMissingDetails: {
      de: "Person mit fehlenden Angaben",
    },
    begruendungBeschreibungBeweiseDocumentDeleteDialogTitle: {
      de: "Beweis: Dokument löschen?",
    },
    begruendungBeschreibungBeweisePersonDeleteDialogTitle: {
      de: "Beweis: Person löschen?",
    },
    begruendungBeschreibungBeweiseDeleteDialogDocumentDescription: {
      de: "Das folgende Dokument wird aus diesem Abschnitt entfernt:",
    },
    begruendungBeschreibungBeweiseDeleteDialogPersonDescription: {
      de: "Die folgende Person wird aus diesem Abschnitt entfernt:",
    },
    begruendungBeschreibungDeleteDialogTitle: {
      de: "und dazugehörige Beweise löschen?",
    },
    begruendungBeschreibungDeleteDialogDescription: {
      de: "Falls Sie hier genannte Beweise auch in einem anderen Abschnitt angegeben haben, bleiben sie dort erhalten.",
    },
    begruendungBeschreibungReuseDocumentDialogTitle: {
      de: "Beweis: Welches Dokument möchten Sie angeben?",
    },
    begruendungBeschreibungReusePersonDialogTitle: {
      de: "Beweis: Welche Person möchten Sie angeben?",
    },
    begruendungBeschreibungReuseDocumentDialogDescription: {
      de: "Dokument wiederverwenden",
    },
    begruendungBeschreibungReusePersonDialogDescription: {
      de: "Person wiederverwenden",
    },
    dialogDocumentReuseOption: {
      de: "Ein bereits genanntes Dokument erneut angeben",
    },
    dialogDocumentNewOption: {
      de: "Ein neues Dokument beschreiben",
    },
    dialogPersonReuseOption: {
      de: "Eine bereits genannte Person erneut angeben",
    },
    dialogPersonNewOption: {
      de: "Eine neue Person beschreiben",
    },
    dialogPersonKlagendeOption: {
      de: "Die klagende Person (mich selbst)",
    },
    dialogPersonBeklagteOption: {
      de: "Die beklagte Person",
    },
    reuseBeweisDocumentSelectionRequired: {
      de: "Bitte wählen Sie mindestens ein Dokument aus.",
    },
    reuseBeweisPersonSelectionRequired: {
      de: "Bitte wählen Sie mindestens eine Person aus.",
    },
  },
  geldEinklagenAnwaltschaft: {
    einzelkanzleiHeadline: {
      de: "Einzelkanzlei",
    },
    berufsausuebungsgesellschaftHeadline: {
      de: "Berufsausübungsgesellschaft",
    },
    geschaeftszeichen: {
      de: "Geschäftszeichen",
    },
    prozessbevollmaechtigtePerson: {
      de: "Prozessbevollmächtigte Person",
    },
    prozessbevollmaechtigtePersonen: {
      de: "Prozessbevollmächtigte Personen",
    },
    namedInSignatureLabel: {
      de: "(Wird in der Signatur genannt)",
    },
    gesamteKanzlei: {
      de: "Gesamte Kanzlei",
    },
    noGeschaeftszeichen: {
      de: "Keine Angabe",
    },
    einzelkanzleiDeleteTitle: {
      de: "Einzelkanzlei löschen?",
    },
    einzelkanzleiDeleteDescription: {
      de: "Die folgende Einzelkanzlei wird entfernt:",
    },
    signaturangabenTitle: {
      de: "Signaturangaben (notwendig für die Klageschrift)",
    },
    additionalPersonsSubtitle: {
      de: "Geben Sie mindestens eine Person an, maximal 5",
    },
    signaturangaben: {
      de: "Signaturangaben",
    },
    signaturangabenDeletionTitle: {
      de: "Signaturangaben löschen?",
    },
    prozessbevollmaechtigtePersonenDeletionTitle: {
      de: "Prozessbevollmächtigte Personen löschen?",
    },
    additionalPersonDeletionDescription: {
      de: "Die folgende Person wird entfernt:",
    },
    berufsausuebungsgesellschaftDeleteTitle: {
      de: "Berufsausübungsgesellschaft löschen?",
    },
    berufsausuebungsgesellschaftDeleteDescription: {
      de: "Die folgende Berufsausübungsgesellschaft wird entfernt:",
    },
    zahlungsklageReferenzzeichenError: {
      de: "Sie müssen entweder „Bezeichnung“ und „Nummer” angeben oder keines von beiden",
    },
    natuerlichePersonHeadline: {
      de: "Natürliche Person",
    },
    natuerlichePersonenHeadline: {
      de: "Natürliche Personen",
    },
    gesetzlicheVetretungHeadline: {
      de: "Gesetzliche Vertretung",
    },
    gesetzlicheVetretungDeletionTitle: {
      de: "Gesetzliche Vertretung löschen?",
    },
    gesetzlicheVetretungOrganisationHeadline: {
      de: "Weitere gesetzliche Vertretung",
    },
    gesetzlicheVetretungSubheader: {
      de: "Maximal 5",
    },
    gesetzlicheVertretungArt: {
      de: "Art der Vertretung",
    },
    gesetzlicheVertretungDeletionLabel: {
      de: "und gesetzliche Vertretung",
    },
    natuerlichePersonenMaximumReachedTitleNotice: {
      de: "Maximale Anzahl an natürlichen Personen erreicht",
    },
    natuerlichePersonenMaximumReachedContentNotice: {
      de: "Mit diesem Onlinedienst können Sie nicht mehr als 5 klagende natürliche Personen hinzufügen.",
    },
    beklagteNatuerlichePersonenMaximumReachedContentNotice: {
      de: "Mit diesem Onlinedienst können Sie nicht mehr als 5 beklagte natürliche Personen hinzufügen.",
    },
    klagendeParteiHeadline: {
      de: "Klagende zu",
    },
    beklagteParteiHeadline: {
      de: "Beklagte zu",
    },
    organisationHeadline: {
      de: "Organisation",
    },
    organisationDescription: {
      de: "Darunter fallen alle, die keine natürlichen Personen sind. Dazu gehören zum Beispiel juristische Personen, Personengesellschaften oder Gebietskörperschaften. Aus technischen Gründen lässt sich die GmbH & CO KG derzeit nicht abbilden.",
    },
    organisationenHeadline: {
      de: "Organisationen",
    },
    organisationMaximumReachedTitleNotice: {
      de: "Maximale Anzahl an Organisationen erreicht",
    },
    organisationMaximumReachedContentNotice: {
      de: "Mit diesem Onlinedienst können Sie nicht mehr als 5 klagende Organisationen hinzufügen.",
    },
    beklagteOrganisationMaximumReachedContentNotice: {
      de: "Mit diesem Onlinedienst können Sie nicht mehr als 5 beklagte Organisationen hinzufügen.",
    },
    soenstigeProzessantragArrayButton: {
      de: "Antrag oder prozessuale Ausführung hinzufügen",
    },
    soenstigeProzessantragItem: {
      de: "Antrag/Ausführung",
    },
    soenstigeProzessantragDelete: {
      de: "Antrag/Ausführung löschen?",
    },
    soenstigeProzessantragInlineNoticeTitle: {
      de: "Maximale Anzahl an sonstigen Anträgen und prozessualen Ausführungen erreicht",
    },
    soenstigeProzessantragInlineNoticeContent: {
      de: "Mit diesem Onlinedienst können Sie nicht mehr als 10 sonstige Anträge und prozessuale Ausführungen hinzufügen.",
    },
    bezifferterZahlungsantragHeadline: {
      de: "Bezifferter Zahlungsantrag",
    },
    bezifferterZahlungsantragCheckboxesHint: {
      de: "Wenn Sie mehr als eine Person auswählen, werden die Personen im Antrag automatisch als Gesamtschuldner aufgeführt. Wählen Sie bitte nur eine Person aus, wenn im Antrag keine Gesamtschuldnerschaft genannt werden soll. Fügen Sie für getrennte Forderungen gegen einzelne Beklagte bitte separate Zahlungsanträge hinzu.",
    },
    bezifferterZahlungsantragCheckboxesBeklagteLabel: {
      de: "Beklagte:",
    },
    bezifferterZahlungsantragCheckboxesKlagendeLabel: {
      de: "Klagende:",
    },
    bezifferterZahlungsantragCheckboxesLeistungLabel: {
      de: "Zahlung zu leisten von",
    },
    bezifferterZahlungsantragInlineNoticeTitle: {
      de: "Achtung: Löschen hat Auswirkungen auf bereits erstellte Tatsachenvorträge",
    },
    bezifferterZahlungsantragDeleteWarning: {
      de: `<p>Sie haben mindestens einen Tatsachenvortrag erstellt, der mit dem allgemeinen Zahlungsantrag \${itemIndex + 1} oder möglichen dazugehörigen Nebenanträgen/Feststellungsantrag auf Annahmeverzug verknüpft ist. Wenn Sie den allgemeinen Zahlungsantrag \${itemIndex + 1} löschen, werden auch damit verknüpfte Tatsachenvorträge gelöscht. Ohne Bezug wären diese unzulässig.</p><br />
<strong>Das können Sie tun:</strong><br />
<li><strong>Behalten und bearbeiten:</strong></li><br />
<p>Falls Sie lediglich die Angaben für den allgemeinen Zahlungsantrag \${itemIndex + 1} ändern möchten, behalten und bearbeiten Sie diesen, anstatt ihn zu löschen. So bleiben Ihre bereits erstellten Tatsachenvorträge unverändert erhalten. Prüfen Sie bitte nach einer Bearbeitung dennoch die Vollständigkeit und Richtigkeit Ihrer dazugehörigen Tatsachenvorträge.</p><br />
<li><strong>Endgültig löschen:</strong></li><br />
<p>Falls Sie den allgemeinen Zahlungsantrag \${itemIndex + 1} mitsamt den Tatsachenvorträgen wirklich löschen möchten, prüfen Sie bitte im Anschluss die Vollständigkeit und Richtigkeit Ihrer verbleibenden Tatsachenvorträge.</p>`,
    },
    bezifferterZahlungsantragItemsToDelete: {
      de: "Der folgende Zahlungsantrag wird inklusive dazugehöriger Nebenanträge/Feststellungsantrag auf Annahmeverzug entfernt:",
    },
    zahlungsAntragHinzufuegen: {
      de: "Zahlungsantrag hinzufügen",
    },
    zahlungsAntragInlineNoticeTitle: {
      de: "Maximale Anzahl an Zahlungsanträgen erreicht",
    },
    zahlungsAntragInlineNoticeContent: {
      de: "Mit diesem Onlinedienst können Sie nicht mehr als 10 Zahlungsanträge hinzufügen.",
    },
    nebenantrag: {
      de: "Nebenantrag",
    },
    annahmeverzug: {
      de: "Annahmeverzug",
    },
    feststellungsantrag: {
      de: "Feststellungsantrag",
    },
    nebenantragHeadline: {
      de: "Nebenanträge / Feststellung Annahmeverzug",
    },
    nebenantragDescription: {
      de: "Maximal 7 (inklusive Annahmeverzug)",
    },
    nebenatragAddButton: {
      de: "Nebenantrag hinzufügen",
    },
    nebenantragInlineNoticeTitle: {
      de: "Achtung: Löschen hat Auswirkungen auf bereits erstellten Tatsachenvortrag",
    },
    nebenantragInlineNoticeAntragToDelete: {
      de: "Der folgende Antrag wird entfernt:",
    },
    nebenantragDeleteWarning: {
      de: `<p>Sie haben bereits einen Tatsachenvortrag erstellt, der mit diesem \${itemLabel} verknüpft ist. Wenn Sie diesen Antrag löschen, wird auch der damit verknüpfte Tatsachenvortrag gelöscht. Ohne Bezug wäre dieser unzulässig.</p><br />
<strong>Das können Sie tun:</strong><br />
<li><strong>Behalten und bearbeiten:</strong></li><br />
<p>Falls Sie lediglich die Angaben für diesen \${itemLabel} ändern möchten, behalten und bearbeiten Sie diesen, anstatt ihn zu löschen. So bleibt Ihr bereits erstellter Tatsachenvortrag unverändert erhalten. Prüfen Sie bitte nach einer Bearbeitung dennoch die Vollständigkeit und Richtigkeit Ihres dazugehörigen Tatsachenvortrags.</p><br />
<li><strong>Endgültig löschen:</strong></li><br />
<p>Falls Sie den \${itemLabel} mitsamt dem Tatsachenvortrag wirklich löschen möchten, prüfen Sie bitte im Anschluss die Vollständigkeit und Richtigkeit Ihrer verbleibenden Tatsachenvorträge.</p>`,
    },
    annahmeverzugAddButton: {
      de: "Annahmeverzug hinzufügen",
    },
    addVortragButton: {
      de: "Vortragen",
    },
    absatz: {
      de: "Absatz",
    },
    absatzInlineNoticeTitle: {
      de: "Maximale Anzahl an Absätzen erreicht",
    },
    absatzInlineNoticeContent: {
      de: "Mit diesem Onlinedienst können Sie nicht mehr als 50 Absätze hinzufügen.",
    },
    beweisangeboteTitle: {
      de: "Beweisangebote",
    },
    beweisangeboteSubtitle: {
      de: "Maximal 50",
    },
    beweis: {
      de: "Beweis",
    },
    beweisangebotDeletionTitle: {
      de: "Beweisangebot löschen?",
    },
    beweisangebotDeletionDescription: {
      de: "Das folgende Beweisangebot wird aus diesem Absatz entfernt:",
    },
    beweisangebotPersonDeletionTitle: {
      de: "Beweisangebot: Person löschen?",
    },
    beweisangebotPersonDeletionDescription: {
      de: "Die folgende Person wird aus diesem Absatz entfernt:",
    },
    optionalSuffix: {
      de: " - Optional",
    },
    undBeweisangebote: {
      de: "und Beweisangebote",
    },
    undDazugehoerigeBeweisangebote: {
      de: "und dazugehörige Beweisangebote",
    },
    addAbsatzButton: {
      de: "Absatz hinzufügen",
    },
  },
  nachlass: {
    childOf: {
      de: "Kind von",
    },
    noParentName: {
      de: "Keine Angabe",
    },
    verstorbenePerson: {
      de: "Verstorbene Person",
    },
    deceased: {
      de: "verstorben",
    },
    deathDateBeforeBirthDateError: {
      de: "Der Zeitpunkt des Todes kann nicht vor dem Geburtsdatum liegen.",
    },
    birthDateAfterDeathDateError: {
      de: "Der Zeitpunkt der Geburt kann nicht nach dem Todeszeitpunkt liegen.",
    },
  },
  personSummaryItem: {
    missingData: {
      de: "Fehlende Angaben",
    },
    personName: {
      de: "Name",
    },
    personBirthDate: {
      de: "Geburtsdatum",
    },
    personBirthPlace: {
      de: "Geburtsort",
    },
    personAliveAtTimeOfDeath: {
      de: "Lebte zum Todeszeitpunkt?",
    },
    yes: {
      de: "Ja",
    },
    no: {
      de: "Nein",
    },
    personAddress: {
      de: "Adresse",
    },
    personDeathDate: {
      de: "Sterbedatum",
    },
    personDeathPlace: {
      de: "Sterbeort",
    },
    personHadChildren: {
      de: "Hatte weitere Kinder?",
    },
  },
  hubPages: {
    tableOfLinksLabel: {
      de: "Inhalt",
    },
    navigationLabel: {
      de: "Weitere Inhalte zum Thema",
    },
  },
} satisfies TranslationRecord;
